var _path, _polygon, _path2, _polygon2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path12, _polygon3, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 731.41339,
    height: 522.40206,
    viewBox: "0 0 731.41339 522.40206",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M839.8232,519.33991a10.05577,10.05577,0,0,0-6.36384-14.04484l-2.225-35.66551L816.39863,480.798l4.38735,32.15633a10.11027,10.11027,0,0,0,19.03722,6.38559Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "670.203 470.736 681.988 474.115 700.63 430.267 683.237 425.28 670.203 470.736",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M900.13844,660.46526h38.53073a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H915.0253a14.88686,14.88686,0,0,1-14.88686-14.88686v0A0,0,0,0,1,900.13844,660.46526Z",
    transform: "translate(1384.80621 1374.56005) rotate(-164.00055)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "651.32 511.018 639.06 511.017 633.227 463.729 651.322 463.73 651.32 511.018",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M630.30259,507.51431h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H615.41574a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,630.30259,507.51431Z",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M851.70669,507.01821s-7,28,5,85l9,98,23,1-3-106,8-44,20,61-7,43,17,8,19-59s-2-82-10-92Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 646.45669,
    cy: 134.16018,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M867.70669,360.25751s-1.5,3.29851,16.5,1.2607,22-8,22-8l31.5,138.17854-2,12.22691-86,5.09455V491.69675l15-91.7018Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M875.06949,505.525l-27.26221-.51465-.08789-.37988a143.23849,143.23849,0,0,1,.99951-57.22266c5.50586-24.38183-7.00513-57.44824-12.63965-70.5332a7.0185,7.0185,0,0,1,2.83081-8.76172l19.29785-11.57812a9.82607,9.82607,0,0,1,14.57764,5.999l3.374,13.23633c15.5398,16.71,14.4502,50.9834,10.79224,76.81836a363.14376,363.14376,0,0,1-11.7688,52.582Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M844.20669,365.51821l-2.35815,1.61347A29.60763,29.60763,0,0,0,830.45267,382.114a71.49867,71.49867,0,0,0-2.746,10.90424c-2,12-11,63-11,63l-4,50,22-5,10-58,10-36Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M922.444,505.76332l-.20752-.57519c-1.43018-3.96387-34.80371-97.335-19.04126-130.25977L901.651,359.487a10.03581,10.03581,0,0,1,13.01953-10.56543l24.11792,7.64648a4.83558,4.83558,0,0,1,3.395,4.68652c-.09985,8.876-.59033,31.49805-2.981,49.82813-2.95581,22.66113,6.89673,79.28027,6.99658,79.84961l.05909.33594Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M911.81454,480.93719a10.05575,10.05575,0,0,1,12.0113-9.66873l18.06206-30.83409L950.097,457.091l-18.41059,26.72693a10.11027,10.11027,0,0,1-19.87191-2.88075Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M935.20669,356.51821l1.29339.29847a9.89494,9.89494,0,0,1,7.05745,6.2142l22.14916,59.98733-26,57-9.5-23.5,12-26-21.5-27.5Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M905.64455,326.35432a60.67581,60.67581,0,0,0,3.15352-11.25447,20.28422,20.28422,0,0,0-1.30963-11.45969,24.91728,24.91728,0,0,0-6.772-8.11883,63.65743,63.65743,0,0,0-6.05995-4.56073c-5.94235-3.941-7.23554-.355-14.36319-1.16163s-15.11474-2.85661-20.82775,1.39774a23.32228,23.32228,0,0,0-8.40929,24.65242c1.59274,5.41955.32508,7.20585,5.2426,10.135a19.18083,19.18083,0,0,1,5.18857-13.13077,19.94828,19.94828,0,0,1,12.93909-6.1202c3.79026-.27467,7.56549.534,11.27656,1.33779,3.60068.77985,7.29829,1.59959,10.35056,3.62759,5.05843,3.36093,7.42988,9.36311,9.51482,14.99332",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 233,
    width: 436,
    height: 2,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 155,
    width: 436,
    height: 2,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 77,
    width: 436,
    height: 2,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 347.80005,
    width: 2,
    height: 312,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 260.6001,
    width: 2,
    height: 312,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 173.40002,
    width: 2,
    height: 312,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.19995,
    width: 2,
    height: 312,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 78,
    width: 175,
    height: 78,
    fill: "#3b82f6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M409.21457,338.862",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#3b82f6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "87 150 87 234 178 153 87 150",
    fill: "#3b82f6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M496.29331,341.799v3l-1.14014,1.01-2.2998,2.04c-44.73,1.35-80.85987,33.39-82.49024,73.12l-2.0498,1.82-.02.01v-84Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#3b82f6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M495.79331,345.799c-.21,0-.43018,0-.64014.01-47.57959.3-86.25,34.62-86.83984,76.98-.02.34-.02.67-.02,1.01,0,43.01,39.25,78,87.5,78s87.5-34.99,87.5-78S544.04331,345.799,495.79331,345.799Zm0,154c-47.14014,0-85.5-34.09-85.5-76,0-.95.02-1.89.06982-2.83,1.63037-39.73,37.76026-71.77,82.49024-73.12.97021-.04,1.9497-.05,2.93994-.05,47.14013,0,85.5,34.09,85.5,76S542.93344,499.799,495.79331,499.799Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M447.79331,422.81508l-5-.02783c.00219-.44482.803-44.48047,51.95117-47.53467l.29785,4.99121C448.65427,383.01381,447.80661,421.19155,447.79331,422.81508Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M546.27329,421.799a42.53605,42.53605,0,0,0-13.98-30.11,53.43668,53.43668,0,0,0-36.39991-13.95h-.10009c-27.46973,0-49.89014,19.67-50.48,44.06-.02.33-.02.67-.02,1,0,12.76,5.97021,24.29,15.5498,32.49a53.64325,53.64325,0,0,0,34.9502,12.57h.10009c27.79981-.05,50.39991-20.24,50.39991-45.06C546.29331,422.469,546.29331,422.129,546.27329,421.799Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M532.29331,391.689l-1.5,1.33-68.4502,60.94-1.5,1.33c-9.57959-8.2-15.5498-19.73-15.5498-32.49,0-.33,0-.67.02-1,.58984-24.39,23.01025-44.06,50.48-44.06h.10009A53.43668,53.43668,0,0,1,532.29331,391.689Z",
    transform: "translate(-234.29331 -188.79897)",
    fill: "#3b82f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingLogo);
export default __webpack_public_path__ + "static/media/branding-logo.0af853e2eed78b84f0abc5d07f91b1a5.svg";
export { ForwardRef as ReactComponent };